import { Authentication, SignUp } from "@/models/auth.model";
import api from "@/services/api-config/rxjs-config";
import { useAuthStore } from "@/store/auth";
import axios from "axios";
import { Observable } from "rxjs";

export class AuthRest {
  loginUser(data: Authentication): Observable<any> {
    const url: string = `/authenticate`;
    return api.post(url, data);
  }

  signUpUser(data: SignUp): Observable<any> {
    const url: string = `/user/signup`;
    return api.post(url, data);
  }

  signUpUserComplete(data: SignUp, token: string): Observable<any> {
    const url: string = `/validate/${token}/user`;
    return api.post(url, data);
  }

  validateToken(token: string): Observable<any> {
    const url: string = `/validate/${token}/user`;
    return api.get(url);
  }

  forgotPasswordEmail(data: any): Observable<any> {
    const url: string = `/user/email-change-password`;
    return api.post(url, data);
  }

  forgotPassword(token: string, data: any): Observable<any> {
    const url: string = `/user/${token}/forgot-password`;
    return api.post(url, data);
  }

  static async refresh(
    refreshToken: string
  ): Promise<{ accessToken: string; refreshToken: string }> {
    try {
      const response = await axios.post("/api/refresh-token", { refreshToken });
      return {
        accessToken: response.data.accessToken,
        refreshToken: response.data.refreshToken,
      };
    } catch (err) {
      throw err;
    }
  }

  static async logout(
    refreshToken: string,
    accessToken: string
  ): Promise<void> {
    await axios
      .post(
        "/api/logout",
        { refreshToken },
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      )
      .finally(() => useAuthStore.reset());
  }
}
